import useStyles from '../AppCssBaseline/styles';

const AppCssBaseline = ({ children }) => {
  useStyles();
  return children;
};

export default AppCssBaseline;
